//
// Copyright (c) 2026 Comcast
//

/*
 * Event-only slice for neutral routing actions used outside React components.
 * Purpose: let app listeners and reducers control React Router without direct router hooks.
 * Actions:
 *   - `locationChanged`: emitted by the router listener when { pathname, search, hash } change;
 *       features subscribe via extraReducers/listeners to react (e.g., clear/reset on route change).
 *   - `navigate`: command action to request navigation from non-component code (e.g., sign-out flow);
 *       the router listener receives it and performs `router.navigate(...)`.
 * Usage example: after sign out, dispatch `navigate(redirectUrl)` to redirect;
 *                the router listener executes the actual navigation.
 * No state: this slice does not store routing data and is not included in rootReducer.
 */
import { createSlice } from '@reduxjs/toolkit'

const routingSlice = createSlice({
  name: 'routing',
  initialState: {},
  reducers: {
    // payload: { pathname, search, hash, state, key }
    locationChanged: (state, action) => {},
    // payload: string | number | { to, options }
    navigate: (state, action) => {},
  },
})

export const { locationChanged, navigate } = routingSlice.actions

export default routingSlice.reducer
